import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { MdMailOutline, MdOutlinePhone } from "react-icons/md";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { InputAdornment } from "@mui/material";
import { ShareViaForm } from "../product-page/components/ShareQuotePopup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import TextInput from "../../pages/product-page/EligibilityCard/components/TextInput/TextInput";
import {
  useGetCartQuery,
  useShareQuoteMutation,
} from "../riders/services/rider";
import { allowOnlyNumbers, restrictSpace } from "./inputUtils/onInput";
import { SiWhatsapp } from "react-icons/si";
import { useNumberInput } from "../../utils";
import { patchEnquiries } from "../product-page/Filters/serviceApi";
import { selectAddedRiders } from "../product-page/Quotes/quotes.slice";

const ShareProposalPopup = () => {
  const { data: userData } = useSelector(state => state.inputForm);
  const [verifyError, setVerifyError] = useState(false);
  const { tenant } = useSelector(state => state.frontendBoot?.frontendData);
  return (
    <div>
      <ShareProposalOnMailForm setVerifyError={setVerifyError} />
      {verifyError?.email?.message && <div style={{ height: "23px" }} />}
      {tenant?.name !== "TMIBASL" && (
        <ShareOnWhatsappForm mobile={userData.mobile} />
      )}
      <ShareProposalViaText />
    </div>
  );
};

export default ShareProposalPopup;

const schema = yup.object({
  email: yup.string().email().required("Please enter email"),
});

const mobileSchema = yup.object({
  mobile: yup
    .number()
    .integer()
    .typeError("Please enter a valid phone number")
    .required("Required"),
});

function ShareProposalOnMailForm({ setVerifyError }) {
  const [shareQuotes, { isLoading }] = useShareQuoteMutation();
  const { data } = useSelector(state => state.inputForm);
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { email: data.email || "" },
    resolver: yupResolver(schema),
  });
  const [email, setEmail] = useState(data.email);
  setVerifyError(errors);
  const onSubmit = async formData => {
    shareQuotes({
      purpose: "proposal",
      email: formData.email,
      via: "email",
      sms: "",
      mode: ["EMAIL"],
      stage: "PROPOSAL",
      whatsapp: "",
    }).then(res => {
      if (res.error) {
        toast.error("Sharing Failed!", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      } else {
        toast.success("Proposal Shared Successfully!", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      }
    });
  };

  return (
    <ShareViaForm onSubmit={handleSubmit(onSubmit)} isLoading={isLoading}>
      <TextInput
        error={errors.email && errors.email.message}
        {...register("email")}
        value={email}
        onChange={evt => {
          register("email").onChange(evt);
          setEmail(evt.target.value);
          setValue("email", evt.target.value);
        }}
        label="Email*"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MdMailOutline className="fs-6" />
            </InputAdornment>
          ),
        }}
        onInput={restrictSpace}
      />
    </ShareViaForm>
  );
}
export function ShareOnWhatsappForm({ mobile, imageUrl, allProducts }) {
  const [phone, handleChange] = useNumberInput(mobile);
  const addedRiders = useSelector(selectAddedRiders);
  const [shareQuotes, { isLoading }] = useShareQuoteMutation();
  const [error, setError] = useState(false);
  useEffect(() => {
    if (phone.length === 10) setError(false);
  }, [phone]);
  const handleSubmit = async evt => {
    evt.preventDefault();
    await patchEnquiries({
      input: {
        selected_addons: addedRiders,
      },
    });
    if (phone.length === 10) {
      setError(false);
      shareQuotes({
        purpose: "proposal",
        groupCode: "10003511",
        mode: ["WHATSAPP"],

        via: "whatsapp",
        stage: "PROPOSAL",
        whatsapp: phone,
      }).then(res => {
        if (res.error) {
          toast.error("Sharing Failed!", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        } else {
          toast.success("Proposal Shared Successfully!", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        }
      });
    } else setError("Please enter a valid whatsapp no.");
  };

  return (
    <ShareViaForm onSubmit={handleSubmit} isLoading={isLoading}>
      <TextInput
        label=" Whatsapp Number"
        variant="outlined"
        error={error}
        value={phone}
        name="phone"
        onChange={handleChange}
        inputProps={{
          minLength: 2,
          maxLength: 10,
          pattern: "[0-9]*",
          inputMode: "numeric",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SiWhatsapp className="fs-6" />
            </InputAdornment>
          ),
        }}
      />
    </ShareViaForm>
  );
}
function ShareProposalViaText() {
  const [shareQuotes, { isLoading }] = useShareQuoteMutation();
  const { data: cartData } = useGetCartQuery();
  const { data } = useSelector(state => state.inputForm);
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { mobile: data.mobile },
    resolver: yupResolver(mobileSchema),
  });
  const [mobile, setMobile] = useState(data.mobile);

  const onSubmit = async formData => {
    shareQuotes({
      purpose: "proposal",
      mobile: formData.mobile,
      sms: formData.mobile,
      via: "sms",
      mode: ["SMS"],
      stage: "PROPOSAL",
      whatsapp: "",
      product_id: cartData?.product?.id,
    }).then(data => {
      if (data.error) {
        toast.error("Sharing Failed!", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      } else {
        toast.success("Compare Shared Successfully!", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      }
    });
  };

  return (
    <ShareViaForm onSubmit={handleSubmit(onSubmit)} isLoading={isLoading}>
      <TextInput
        error={errors.mobile && errors.mobile.message}
        {...register("mobile")}
        value={mobile}
        onChange={evt => {
          register("mobile").onChange(evt);
          setMobile(evt.target.value);
          setValue("mobile", evt.target.value);
        }}
        onInput={allowOnlyNumbers}
        label="Mobile"
        inputProps={{
          minLength: 2,
          maxLength: 10,
          pattern: "[0-9]*",
          inputMode: "numeric",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MdOutlinePhone className="fs-6" />
            </InputAdornment>
          ),
        }}
      />
    </ShareViaForm>
  );
}
